import SEO from "../components/SEO";
import seoPages from "../data/seoPages.json";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

export const PublicOfferPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO {...seoPages.publicOffer} />
      <Header />
      
      <main className="max-w-4xl mx-auto px-6 pt-32 pb-16">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
          Публичная оферта
        </h1>
        
        <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
          <p>
            Индивидуальный предприниматель Фокеев Дмитрий Сергеевич, ИНН 780626085106, ОГРНИП 324784700300420 (далее – «Исполнитель»), руководствуясь ст. 437 Гражданского кодекса Российской Федерации, предлагает любому дееспособному физическому лицу (далее – «Покупатель» или «Заказчик») заключить настоящий договор-оферту на изложенных ниже условиях.
          </p>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              1. Общие положения
            </h2>
            <p>
              1.1. Настоящая Публичная оферта (далее – «Оферта», «Договор») определяет порядок и условия предоставления услуг Исполнителем, а также права и обязанности сторон, возникающие в связи с заключением и исполнением данного Договора.
            </p>
            <p>
              1.2. Безоговорочным акцептом (принятием) условий настоящей Оферты считается совершение Покупателем действий по оформлению заказа и/или оплате услуг Исполнителя. С момента оплаты услуги Оферта считается заключённой и обязывает стороны к исполнению её условий.
            </p>
            <p>
              1.3. Текст Оферты постоянно размещён в сети Интернет на сайте Исполнителя или на страницах лендингов, связанных с продажей онлайн-курсов. Исполнитель оставляет за собой право вносить изменения в Оферту в одностороннем порядке. Новая редакция Оферты вступает в силу с момента её размещения на сайте, если иное не указано дополнительно.
            </p>
            <p>
              1.4. Покупатель обязуется самостоятельно отслеживать возможные изменения в тексте Оферты.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              2. Термины и определения
            </h2>
            <p>В рамках настоящей Оферты нижеприведённые термины используются в следующем значении:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li><strong>Онлайн-курсы</strong> – аудио-, видео-, текстовые материалы, обучающий контент, доступные для просмотра и изучения в личном кабинете на обучающей платформе Исполнителя.</li>
              <li><strong>Личный кабинет</strong> – закрытая (личная) часть платформы, где Покупатель получает доступ к курсам после оплаты.</li>
              <li><strong>Сайт</strong> – веб-сайт/лендинги Исполнителя, на которых размещается информация об онлайн-курсах и оформляется заказ.</li>
              <li><strong>Услуга</strong> – предоставление доступа к Онлайн-курсам и обучающим материалам Исполнителя.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              3. Предмет Оферты
            </h2>
            <p>
              3.1. Исполнитель обязуется предоставить Покупателю доступ к онлайн-курсам (видео, аудио, текстовый контент и иные обучающие материалы) на условиях, изложенных в настоящем Договоре.
            </p>
            <p>
              3.2. Доступ к курсу предоставляется сроком на 3 (три) года с момента, когда Покупатель получил соответствующее подтверждение (ссылку на доступ) после оплаты.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              4. Порядок оформления заказа и оказания услуг
            </h2>
            <p className="font-medium">4.1. Оформление заказа:</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>Покупатель выбирает интересующий его онлайн-курс на сайте (или лендинге) Исполнителя.</li>
              <li>Для приобретения курса Покупатель заполняет необходимые данные и осуществляет оплату курса в режиме онлайн.</li>
            </ul>
            <p className="font-medium mt-4">4.2. Оплата и подтверждение:</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>Оплата производится посредством онлайн-платежа (банковская карта) через платёжную систему, интегрированную на сайте Исполнителя.</li>
              <li>Факт оплаты подтверждается автоматическим уведомлением (чеком) на электронную почту Покупателя.</li>
            </ul>
            <p className="font-medium mt-4">4.3. Получение доступа:</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>После успешной оплаты Покупатель в течение 24 (двадцати четырёх) часов получает на свою электронную почту ссылку для входа в личный кабинет на обучающей платформе.</li>
              <li>В случае технических задержек, связанных с платёжной системой или иными независящими от Исполнителя обстоятельствами, срок может быть увеличен, но не более чем на 48 (сорок восемь) часов.</li>
            </ul>
            <p className="mt-4">
              4.4. Доступ к материалам курса сохраняется для Покупателя на срок 3 (трёх) лет с момента предоставления ссылки, если иное не оговорено отдельно.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              5. Цена и порядок оплаты
            </h2>
            <p>
              5.1. Стоимость каждого онлайн-курса указана на соответствующем лендинге/странице продажи. Исполнитель вправе проводить акции и предоставлять скидки; в этом случае цена и условия акции указываются дополнительно.
            </p>
            <p>
              5.2. Покупатель самостоятельно выбирает желаемый курс и способ оплаты (онлайн-оплата банковской картой).
            </p>
            <p>
              5.3. Моментом оплаты считается зачисление денежных средств на расчётный счёт Исполнителя (через платёжного агрегатора или иным способом).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              6. Порядок возврата средств
            </h2>
            <p>
              6.1. Так как приобретаемые услуги относятся к цифровым информационным продуктам, которые передаются в электронном виде, возврат средств возможен только при соблюдении нижеприведённых условий.
            </p>
            <p>
              6.2. Покупатель вправе запросить возврат в течение 30 (тридцати) дней с момента покупки при условии, что Покупатель не прошёл более 25% курса.
            </p>
            <p>
              6.3. Для возврата средств Покупатель направляет запрос Исполнителю через личный кабинет на платформе либо иным способом, предусмотренным сайтом. В запросе Покупатель указывает причину возврата.
            </p>
            <p>
              6.4. Исполнитель рассматривает заявку на возврат в течение 2 (двух) рабочих дней с момента получения запроса. При удовлетворении запроса деньги возвращаются тем же способом, которым была произведена оплата (на карту или счёт).
            </p>
            <p>
              6.5. Возврат может быть отклонён, если Покупатель нарушает условия оферты или если доля курса, пройденная Покупателем, превышает 25%.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              7. Порядок разрешения претензий
            </h2>
            <p>
              7.1. Все претензии, связанные с качеством предоставляемых услуг или порядком их оказания, направляются по адресу электронной почты: dmitriy.fokeev.92@mail.ru.
            </p>
            <p>
              7.2. Срок рассмотрения претензий составляет от 7 (семи) до 10 (десяти) рабочих дней с момента их получения Исполнителем.
            </p>
            <p>
              7.3. Стороны обязуются стремиться к урегулированию возникающих споров и разногласий путём переговоров (досудебного урегулирования). Если спор не может быть урегулирован в претензионном порядке, он подлежит рассмотрению в соответствии с действующим законодательством Российской Федерации по месту регистрации Исполнителя.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              8. Права и обязанности сторон
            </h2>
            <p className="font-medium">8.1. Исполнитель (ИП Фокеев Дмитрий Сергеевич) обязан:</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>Предоставить доступ к онлайн-курсам в полном объёме и в заявленный срок (как правило, в течение 24 часов с момента оплаты).</li>
              <li>Обеспечивать работоспособность сайта и личного кабинета, за исключением случаев, вызванных обстоятельствами, не зависящими от Исполнителя (например, сбои в работе провайдера, платёжных систем и пр.).</li>
              <li>Своевременно реагировать на претензии и обращения Покупателя.</li>
            </ul>
            <p className="font-medium mt-4">8.2. Исполнитель имеет право:</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>Приостанавливать доступ к курсу Покупателю в случае нарушения Покупателем условий настоящей Оферты (в частности, условий копирования и распространения материалов без согласия, нелегального доступа и т.д.).</li>
              <li>Вносить изменения в содержание курсов (обновлять, дополнять материалы), не меняя при этом сути и основных обучающих целей.</li>
            </ul>
            <p className="font-medium mt-4">8.3. Покупатель обязан:</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>Указывать достоверные контактные данные (ФИО, e-mail, телефон) при регистрации и оплате.</li>
              <li>Не распространять публично и не копировать материалы курса без согласия Исполнителя (за исключением тех случаев, когда Исполнитель прямо разрешил делиться материалами, см. раздел 10).</li>
              <li>Своевременно и в полном объёме оплачивать стоимость курсов.</li>
              <li>Соблюдать требования, установленные законодательством, и положения настоящей Оферты.</li>
            </ul>
            <p className="font-medium mt-4">8.4. Покупатель имеет право:</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>Получить доступ к приобретённому курсу на срок, оговорённый в разделе 3.</li>
              <li>Пользоваться материалами курса (смотреть, сохранять, изучать) в личных целях, а также делиться ими с третьими лицами, если это прямо допускается Исполнителем (см. раздел 10).</li>
              <li>Запрашивать разъяснения у Исполнителя по содержанию материалов и возникающим техническим вопросам, касающимся доступа.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              9. Сроки и условия предоставления доступа
            </h2>
            <p>
              9.1. Срок доступа к курсу составляет 3 (три) года с момента отправки ссылки для входа в личный кабинет.
            </p>
            <p>
              9.2. При окончании указанного срока доступ может быть продлён на условиях, предусмотренных Исполнителем (по отдельному соглашению, дополнительной оплате и т.п.).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              10. Интеллектуальная собственность
            </h2>
            <p>
              10.1. Все материалы курсов (видео, аудио, тексты, презентации) являются объектом авторского права Исполнителя, а также иных правообладателей (при привлечении авторов/соавторов).
            </p>
            <p>
              10.2. По умолчанию Покупатель вправе сохранять полученные материалы и использовать их в личных проектах. Разрешение на «делиться» материалами с третьими лицами (пересылать, публиковать и т.д.) — допускается только при условии, что это прямо не противоречит разъяснениям или инструкциям Исполнителя и не нарушает авторские права (например, ссылки на бесплатные фрагменты, разрешённые для свободного распространения, и т.п.).
            </p>
            <p>
              10.3. Запрещается любая коммерческая переработка или перепродажа материалов курса без письменного разрешения Исполнителя.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              11. Ограничение ответственности
            </h2>
            <p>
              11.1. Исполнитель не несёт ответственность за прямые или косвенные убытки, возникшие у Покупателя в результате применения или несоответствующего применения полученных знаний, навыков и информации из курса.
            </p>
            <p>
              11.2. Исполнитель не гарантирует достижение Покупателем каких-либо конкретных результатов (финансовых, карьерных и т.п.) в связи с прохождением курса, поскольку это зависит от множества факторов, находящихся вне контроля Исполнителя.
            </p>
            <p>
              11.3. Исполнитель не несёт ответственность за сбои в работе платёжных систем, банков, интернет-провайдеров, а также за качество интернет-соединения у Покупателя.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              12. Конфиденциальность и персональные данные
            </h2>
            <p>
              12.1. В целях исполнения настоящего Договора Исполнитель обрабатывает персональные данные Покупателя (e-mail, телефон и пр.). Подробная информация о способах и целях обработки содержится в Политике конфиденциальности, размещённой по адресу: <a href="https://dmitrii-fokeev.ru/privacy-policy" className="text-teal-600 hover:underline">https://dmitrii-fokeev.ru/privacy-policy</a>
            </p>
            <p>
              12.2. Персональные данные хранятся в течение максимально допустимого законодательством срока либо до момента отзыва согласия Покупателем, если это не противоречит требованиям закона о хранении данных.
            </p>
            <p>
              12.3. Покупатель соглашается на передачу данных третьим лицам, если это необходимо для обработки оплаты и предоставления доступа на обучающую платформу (например, платёжные системы, банк, сервисы электронной почты и т.д.).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              13. Дополнительные условия
            </h2>
            <p>
              13.1. Исполнитель вправе в одностороннем порядке вносить изменения в содержание онлайн-курсов, если это не ухудшает качество предоставляемых услуг.
            </p>
            <p>
              13.2. Настоящая Оферта и отношения сторон регулируются нормами действующего законодательства Российской Федерации.
            </p>
            <p>
              13.3. Если какие-либо пункты настоящей Оферты признаются недействительными в судебном порядке, это не влечёт недействительности остальных положений Оферты.
            </p>
            <p>
              13.4. Стороны признают юридическую силу электронных писем и уведомлений, отправленных с указанных в Оферте (или в процессе оформления заказа) адресов, как официальную переписку.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              14. Реквизиты Исполнителя
            </h2>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="font-medium">Исполнитель:</p>
              <p>Индивидуальный предприниматель Фокеев Дмитрий Сергеевич</p>
              <p>ИНН: 780626085106</p>
              <p>ОГРНИП: 324784700300420</p>
              <p>E-mail: dmitriy.fokeev.92@mail.ru</p>
            </div>
          </section>

          <section className="mt-8 pt-8 border-t border-gray-200">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              Заключительные положения
            </h2>
            <p>
              Оплачивая услугу, Покупатель выражает полное и безоговорочное согласие со всеми пунктами настоящей Публичной оферты и обязан соблюдать изложенные в ней условия.
            </p>
            <p className="mt-4 text-gray-500">
              Дата публикации Оферты: «1» апреля 2025 г.
            </p>
          </section>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default PublicOfferPage;
